import React, { ReactElement } from 'react'

import { BoxProps } from '@mindfulchefuk/design-system/layout/Box'
import { Svg } from '../../Svg'

export const MinusIcon = (props: BoxProps): ReactElement => (
  <Svg viewBox="0 0 22 20" {...props}>
    <g fill="none" stroke="currentColor">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 10C1 9.44772 1.44772 9 2 9H18C18.5523 9 19 9.44772 19 10C19 10.5523 18.5523 11 18 11H2C1.44772 11 1 10.5523 1 10Z"
        fill="currentColor"
      />
    </g>
  </Svg>
)
